module.exports = __webpack_public_path__ + "img/radiaIcon2.737d9f54.svg";